const doc = [({"zh_tw":({"adminConstantUserType":({"common":"官網群成員", "company":"{{company}} 專屬會員"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;